import { Typography, Box, useTheme, TextField, Divider, Grid, Autocomplete, FormControlLabel, Switch, Card, CardContent, IconButton, Tooltip, Button, CardHeader, FormControl, Select, MenuItem } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../../Layout/Alertbar";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { styled } from "@mui/material/styles";



import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WarehouseMasterMenu from "./ActionMenu";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import BintypeMasterMenu from "./ActionMenu";
import { max, set } from "date-fns";
import { IconBase } from "react-icons/lib";
import { AddCircleOutlineSharp, ArrowBackIos, ArrowDownward, KeyboardArrowDown } from "@mui/icons-material";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { Label } from "recharts";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";

import RequiredLabel from "../../../components/RequiredLabel";
import useWarehouseTypeList from "../../../hooks/warehouse/useWarehouseTypeList";
import useWarehouseEnvironmentTypeList from "../../../hooks/warehouse/useWarehouseEnvironmentTypeList";
import useWarehouseBinTypeList from "../../../hooks/warehouse/useWarehouseBinTypeList";



// ✅ iOS-style custom Switch
const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: "flex",
    "&:active .MuiSwitch-thumb": {
        width: 22,
    },
    "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#2977c1ff", // ✅ Apple green
                opacity: 1,
                border: 0,
            },
        },
    },
    "& .MuiSwitch-thumb": {
        boxShadow: "0 2px 4px 0 rgba(0 0 0 / 0.2)",
        width: 22,
        height: 22,
        borderRadius: 11,
        transition: theme.transitions.create(["width"], {
            duration: 200,
        }),
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === "dark" ? "#39393D" : "#E9E9EA",
        boxSizing: "border-box",
    },
}));


const AddNewBintypeMaster = ({ handleBackWinderMachineEntry, selectedwarehosue }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [warehouseCode, setWarehouseCode] = useState('');
    const [description, setDescription] = useState('');
    const [visibleDelete, setVisibleDelete] = useState(false);
    const [bintypeid, setBintypeid] = useState(0);
    const [wipFlag, setWipFlag] = useState(false);
    const [status, setStatus] = useState(false);
    const [allowMultipleItems, setAllowMultipleItems] = useState(false);
    const [limitType, setLimitType] = useState('');
    const [maxDiffSkus, setMaxDiffSkus] = useState(0);
    const [isStackable, setIsStackable] = useState(false);
    const [verticalgapincm, setVerticalGapInCm] = useState(0);
    const [locationcodeformate, setLocationCodeFormat] = useState('WH01-A1-L1-R1-B1');
    const userPermissions = useUserPermissions();
    const [header, setHeader] = useState(0);
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [enableRejectParentRoll, setEnableRejectParentRoll] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
    const { warehouseTypes, selectedWarehouseType, selectedWarehouseTypeID, setSelectedWarehouseType, setIsWarehouseTypeDataLoaded, loadWarehouseTypeByID } = useWarehouseTypeList(0);
    const { warehouseEnvironmentTypes, selectedWarehouseEnvironmentType, selectedWarehouseEnvironmentTypeID, setSelectedWarehouseEnvironmentType, setIsWarehouseEnvironmentTypeDataLoaded, loadWarehouseEnvironmentTypeByID } = useWarehouseEnvironmentTypeList(0);
    const { warehouseBinTypes, selectedWarehouseBinType, selectedWarehouseBinTypeID, setSelectedWarehouseBinType, setSelectedWarehouseBinTypeID, loadWarehouseBinTypeByID } = useWarehouseBinTypeList(0);
    const [visibleBinlevelConfiguration, setVisibleBinlevelConfiguration] = useState(false);
    const [levels, setLevels] = useState([
        { id: 'Level 1', enabled: false, label: '', count: 0 },
        { id: 'Level 2', enabled: false, label: '', count: 0 },
        { id: 'Level 3', enabled: false, label: '', count: 0 },
        { id: 'Level 4', enabled: false, label: '', count: 0 },
        { id: 'Level 5', enabled: false, label: '', count: 0 }
    ]);

    const configRef = useRef(null);

    useEffect(() => {
        if (visibleBinlevelConfiguration && configRef.current) {
            // smooth scroll into view
            configRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [visibleBinlevelConfiguration]);

    const handleToggle = (index) => {
        const updated = [...levels];
        updated[index].enabled = !updated[index].enabled;
        setLevels(updated);
    };

    const handleChange = (index, field, value) => {
        const updated = [...levels];
        updated[index][field] = value;
        setLevels(updated);
    };

    const activeLevels = levels.filter(l => l.enabled);
    const totalCombinations = activeLevels.reduce((acc, lvl) => acc * (lvl.count || 1), 1);


    const clear = () => {

        setWarehouseCode('');
        setDescription('');

        setBintypeid(0);
        setVisibleDelete(false);
        setHeader(0);
        setStatus(true);

        setLimitType('');
        setMaxDiffSkus(0);
        setIsStackable(false);
        setVerticalGapInCm(0);
        setLocationCodeFormat('WH01-A1-L1-R1-B1');
        setAllowMultipleItems(false);
        setLevels([
            { id: 'Level 1', enabled: false, label: '', count: 0 },
            { id: 'Level 2', enabled: false, label: '', count: 0 },
            { id: 'Level 3', enabled: false, label: '', count: 0 },
            { id: 'Level 4', enabled: false, label: '', count: 0 },
            { id: 'Level 5', enabled: false, label: '', count: 0 }
        ]);
    }





    useEffect(() => {
        if (selectedwarehosue !== null && selectedwarehosue !== undefined) {
            LoadExitingWarehouseList();
        }
        else {
            clear();
        }
    }, [selectedwarehosue]);

    const LoadExitingWarehouseList = () => {
        setWarehouseCode(selectedwarehosue.code);
        setDescription(selectedwarehosue.description);
        setAllowMultipleItems(selectedwarehosue.allow_multiple_items === 1 ? true : false);
        setLimitType(selectedwarehosue.limit_type);
        setMaxDiffSkus(selectedwarehosue.max_different_skus);
        setIsStackable(selectedwarehosue.is_stackable === 1 ? true : false);
        setVerticalGapInCm(selectedwarehosue.vertical_gap_in_cm);
        setLocationCodeFormat(selectedwarehosue.location_code_format);

        setBintypeid(selectedwarehosue.bin_type_id);
        setVisibleDelete(true);
        setHeader(1);
        setStatus(selectedwarehosue.status);

        const levelsData = [
            { id: 'Level 1', enabled: selectedwarehosue.level1_enabled, label: selectedwarehosue.level1_label, count: 0 },
            { id: 'Level 2', enabled: selectedwarehosue.level2_enabled, label: selectedwarehosue.level2_label, count: 0 },
            { id: 'Level 3', enabled: selectedwarehosue.level3_enabled, label: selectedwarehosue.level3_label, count: 0 },
            { id: 'Level 4', enabled: selectedwarehosue.level4_enabled, label: selectedwarehosue.level4_label, count: 0 },
            { id: 'Level 5', enabled: selectedwarehosue.level5_enabled, label: selectedwarehosue.level5_label, count: 0 }
        ];

        setLevels(levelsData);

        // 👇 Check if any level is enabled and has a label
        const anyLevelActive = levelsData.some(
            lvl => lvl.enabled && lvl.label && lvl.label.trim() !== ""
        );

        if (anyLevelActive) {
            setVisibleBinlevelConfiguration(true);
        } else {
            setVisibleBinlevelConfiguration(false);
        }
    }



    const handlesavebintypedetails = (mode, id) => {
        setParentRollMsgOpen(false);

        if (mode === 'DELETE') {
            if (window.confirm("Are you sure you want to delete Bin type?")) {
            }
            else {
                // If user cancels, exit the function
                return;
            }
        }

        let isValid = true;
        let validation_msg = '';
        if (warehouseCode === '') {
            validation_msg += 'Please enter the Bin type Code.\n';
            isValid = false;
        }

        if (description === '') {
            validation_msg += 'Please enter the Bin type Description.\n';
            isValid = false;
        }
        const enabledLevels = levels.filter(lvl => lvl.enabled);

        if (enabledLevels.length === 0) {
            validation_msg += 'Please enable at least one level.\n';
            isValid = false;
        }


        const enabledLevelsWithoutLabel = levels.filter(
            lvl => lvl.enabled && lvl.label.trim() === ''
        );

        if (enabledLevelsWithoutLabel.length > 0) {
            validation_msg += 'Please enter label for all enabled levels.\n';
            isValid = false;
        }



        if (isValid) {
            const SaveData = {
                p_bin_type_id: bintypeid,
                p_code: warehouseCode,
                p_description: description,
                p_allow_multiple_items: allowMultipleItems,
                p_limit_type: limitType,
                p_max_different_skus: maxDiffSkus ? 1 : 0,
                p_max_different_batches: 0,
                p_is_stackable: isStackable ? 1 : 0,
                p_company_id: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_created_by: localStorage.getItem('LoginID'),
                p_updated_by: localStorage.getItem('LoginID'),
                p_level1_enabled: levels[0].enabled,
                p_level2_enabled: levels[1].enabled,
                p_level3_enabled: levels[2].enabled,
                p_level4_enabled: levels[3].enabled,
                p_level5_enabled: levels[4].enabled,
                p_level1_label: levels[0].label,
                p_level2_label: levels[1].label,
                p_level3_label: levels[2].label,
                p_level4_label: levels[3].label,
                p_level5_label: levels[4].label,
                p_location_code_format: locationcodeformate,
                p_vertical_gap_in_cm: verticalgapincm ? parseFloat(verticalgapincm) : 0,
                p_levels: levels,
                p_status: status

            };


            let bintypeAPI = bintypeid === 0 ? Warehouse_API_ENDPOINTS.binType.create : Warehouse_API_ENDPOINTS.binType.update;
            if (mode === 'DELETE') {
                bintypeAPI = Warehouse_API_ENDPOINTS.binType.delete;
            }
            callApi(bintypeAPI, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].message == 'Error: column \"bintype_id\" does not exist') {
                            toast.error('bintype_id does not exist', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].message == 'Error: Cannot delete bin type as it is referenced in another table.') {
                            toast.warning('Cannot delete this bin type because it is already used in storage locations', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].message === 'Bin Type updated successfully') {

                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });


                        }
                        else if (data[0].message === 'Bin Type created successfully') {

                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                            setBintypeid(data[0].warehouse_id);
                            setVisibleDelete(true);
                            setHeader(1);
                        }
                        else if (data[0].message === 'Bin Type deleted successfully') {

                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                            handleBackWinderMachineEntry();
                        }
                        else {
                            toast.error(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'save') {

            if (header === 0) {
                if (!hasPermission(userPermissions, "Bin type", "Create")) {
                    toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                    return; // Exit the function if permission is not granted
                }
            }

            else if (header === 1) {
                if (!hasPermission(userPermissions, "Bin type", "Update")) {
                    toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                    return; // Exit the function if permission is not granted
                }
            }

            handlesavebintypedetails();
        }
        else if (buttonName === 'clear') {

            clear();
        }
        else if (buttonName === 'delete') {
            if (!hasPermission(userPermissions, "Bin type", "Delete")) {
                toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                return; // Exit the function if permission is not granted
            }
            handlesavebintypedetails('DELETE', bintypeid);
        }


    };

    const [expanded, setExpanded] = useState(false);

    // 👇 Auto-expand logic — open accordion if levels have any data
    useEffect(() => {
        const hasData = levels.some(
            (lvl) => lvl.enabled || (lvl.label && lvl.label.trim() !== "")
        );
        setExpanded(hasData);
    }, [levels]);


    return (

        <Box

            fullWidth

        >
            <>
                <BintypeMasterMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} enableRejectParentRoll={enableRejectParentRoll} title={header} callback={handleBackWinderMachineEntry} saveButtonDisabled={saveButtonDisabled} visibleDelete={visibleDelete} header={header} />
                <Divider />
            </>

            <Box
                sx={{
                    padding: "5px",
                    borderRadius: "10px",
                    maxHeight: {
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '74vh', // Large devices (desktops)
                        xl: '82vh', // Extra large devices (large desktops)
                    },
                    overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: colors.primary[400],
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: colors.blueAccent[600],
                        borderRadius: '10px',
                        '&:hover': {
                            background: colors.blueAccent[800],
                        },
                    },
                    '&::-webkit-scrollbar-corner': {
                        background: colors.primary[700],
                    }
                }}>
                <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                    setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                    setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                <Box p={2} spacing={2} >



                    <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                   
                                      <RequiredLabel label="Code" />
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >

                                    <TextField placeholder="Code" disabled={header === 1} size="small" value={warehouseCode} onChange={(e) => setWarehouseCode(e.target.value)} color="secondary" fullWidth />

                                </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    
                                       <RequiredLabel label="Description" />
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 4',
                                        xl: 'span 4',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField size="small" color="secondary" placeholder="Enter Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth />       </Box>

                            </Box>



                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Limit Type</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 4',
                                        xl: 'span 4',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <FormControl fullWidth size="small">
                                        <Select
                                            value={limitType}
                                            onChange={(e) => setLimitType(e.target.value)}
                                            color="secondary"
                                            displayEmpty
                                        >
                                            <MenuItem value="">NONE</MenuItem>
                                            <MenuItem value="WEIGHT">WEIGHT</MenuItem>
                                            <MenuItem value="COUNT">COUNT</MenuItem>
                                            <MenuItem value="VOLUME">VOLUME</MenuItem>
                                        </Select>
                                    </FormControl>



                                </Box>

                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Max Different SKU'S</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField
                                        size="small"
                                        type="number"
                                        color="secondary"
                                        placeholder="Enter Max Different SKU'S"
                                        value={maxDiffSkus}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            // Allow only whole numbers (no decimals, no negatives)
                                            if (/^\d*$/.test(val)) {
                                                setMaxDiffSkus(val);
                                            }
                                        }}
                                        fullWidth
                                    />


                                </Box>

                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Horizontal Object Gap (cm)</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField
                                        size="small"
                                        type="number"
                                        color="secondary"
                                        placeholder="Enter Vertical Gap (cms)"
                                        value={verticalgapincm}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            // Allow only positive numbers with optional decimals (no negatives)
                                            if (/^\d*\.?\d*$/.test(val)) {
                                                setVerticalGapInCm(val);
                                            }

                                        }}
                                        fullWidth
                                    />


                                </Box>

                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Location Code Formate</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 4',
                                        xl: 'span 4',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField
                                        size="small"

                                        color="secondary"

                                        value={locationcodeformate}
                                        disabled
                                        onChange={(e) => {
                                            const val = e.target.value;

                                            setLocationCodeFormat(val);


                                        }}
                                        placeholder="WH01-A1-L1-R1-B1"
                                        fullWidth
                                    />


                                </Box>

                            </Box>
                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Allow Multiple Items</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 5',
                                        xl: 'span 5',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >

                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={allowMultipleItems}
                                                onChange={(e) => setAllowMultipleItems(e.target.checked)}
                                                color="secondary"
                                            />
                                        }
                                        label={allowMultipleItems ? 'True' : 'False'}
                                    />


                                </Box>

                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}

                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Is Stackable</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 5',
                                        xl: 'span 5',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isStackable}
                                                onChange={(e) => setIsStackable(e.target.checked)}
                                                color="secondary"
                                            />
                                        }
                                        label={isStackable ? 'True' : 'False'}
                                    />
                                </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}

                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 2',
                                        xl: 'span 2',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Status</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 5',
                                        xl: 'span 5',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={status}
                                                onChange={(e) => setStatus(e.target.checked)}
                                                color="secondary"
                                                disabled={header === 0}   // <-- this line is the magic
                                            />

                                        }
                                        label={status ? 'Active' : 'Inactive'}
                                    />
                                </Box>
                            </Box>


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}

                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >



                                    <Button
                                        startIcon={<ArrowDropDownIcon sx={{ color: "white" }} />}
                                        onClick={() => setVisibleBinlevelConfiguration(prev => !prev)}
                                        // sx={{ backgroundColor: colors.primary[400] }}
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        <Typography fontSize={'12px'} sx={{ color: "whitesmoke" }}>
                                            Add Warehouse Levels 

                                             
                                        </Typography>

                                     
                                    </Button>


                                </Box>


                            </Box>

                        </Grid>
                    </Grid>
                </Box>



                <Box ref={configRef} sx={{ mt: 0, p: 1 }}>

                    {visibleBinlevelConfiguration && (
                        <>
                            <Box sx={{ p: 1 }}>
                                <Card
                                    elevation={3}
                                    backgroundColor={colors.blueAccent[400]}
                                    color={colors.blueAccent[500]}

                                >
                                    <CardContent sx={{ backgroundColor: colors.primary[400], borderRadius: 2 }}>


                                        <Box sx={{ mb: 2 }}>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: 'text.primary',
                                                }}
                                            >
                                                Warehouse Levels Configuration
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: 'text.secondary',
                                                    mt: 0.5,
                                                }}
                                            >
                                                Define hierarchical levels like Zone, Aisle, Rack, and Bin for your warehouse
                                            </Typography>

                                            <Divider sx={{ mt: 1.5, borderColor: '#ec407a', borderBottomWidth: 2 }} />
                                        </Box>





                                        {levels.map((lvl, i) => (
                                            <Box key={lvl.id} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                {/* Switch Row */}
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={lvl.enabled}
                                                            onChange={() => handleToggle(i)}
                                                            color="secondary"
                                                        />
                                                    }

                                                    label={<Typography fontWeight={600}>{`${lvl.id}`}</Typography>}
                                                />




                                                {/* Inputs Row */}
                                                {/* {lvl.enabled && ( */}
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        mt: 1,
                                                        pl: 0,
                                                    }}
                                                >
                                                    <TextField
                                                        size="small"
                                                        color="secondary"
                                                        value={lvl.label}
                                                        onChange={(e) => handleChange(i, 'label', e.target.value)}
                                                        //   sx={{ flex: 1 }}
                                                        disabled={!lvl.enabled}
                                                        placeholder={`Enter name for ${lvl.id}`}
                                                        sx={{ mx: 0, width: 250 }}
                                                        InputProps={{
                                                            sx: { borderRadius: '6px', height: '36px' },
                                                        }}
                                                    />


                                                </Box>
                                                {/* )} */}
                                            </Box>
                                        ))}
                                    </CardContent>

                                </Card>
                            </Box>


                            {/* <Card className="w-full max-w-2xl">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
           
             <h4>Bin Levels Configuration</h4>

              <h4> Enable and Configure up to 5 bin levels for your system</h4>
          
          </div>
          
        </div>
      </CardHeader>

      <CardContent className="space-y-6">
        

        <div className="space-y-4">
          {config.levels.map((level) => (
            <div
              key={level.id}
              className={`flex items-center gap-4 p-4 rounded-lg border transition-all ${
                config.enabled && level.enabled
                  ? 'bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-800'
                  : 'bg-gray-50 dark:bg-gray-900/50 border-gray-200 dark:border-gray-800 opacity-60'
              }`}
            >
              <div className="flex items-center gap-3 flex-1">
                <Switch
                  checked={level.enabled}
                  onCheckedChange={(enabled) => handleToggleLevel(level.id, enabled)}
                  disabled={!config.enabled}
                />

                <div className="flex-1 space-y-1.5">
                  <Label
                    htmlFor={`level-${level.id}`}
                    className={!config.enabled || !level.enabled ? 'opacity-50' : ''}
                  >
                    Level {level.id}
                  </Label>
                  <Input
                    id={`level-${level.id}`}
                    value={level.name}
                    onChange={(e) => handleLevelNameChange(level.id, e.target.value)}
                    placeholder={`Enter name for Level ${level.id}`}
                    disabled={!config.enabled || !level.enabled}
                    className="h-9"
                  />
                </div>

                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleClearLevel(level.id)}
                  disabled={!config.enabled || !level.enabled}
                  className="shrink-0"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        {config.enabled && (
          <div className="flex justify-end pt-4">
            <Button onClick={handleSave}>Save Configuration</Button>
          </div>
        )}
      </CardContent>
    </Card> */}
                        </>

                    )}












                </Box>
            </Box>
        </Box>
    );
};
export default AddNewBintypeMaster;